import type { MouseEvent } from 'react';
import type { Room, Relations } from '$types/matrix-sdk';
import { useSetAtom } from 'jotai';
import { Text, MenuItem } from 'folds';
import { menuIcon, Smiley } from '$components/icons/phosphor';
import { modalAtom, ModalType } from '$state/modal';
import * as css from '$features/room/message/styles.css';
import { ReactionViewer } from '$features/room/reaction-viewer';

export function MessageAllReactionItem({
  room,
  relations,
  closeMenu,
}: {
  room: Room;
  relations: Relations;
  closeMenu: () => void;
}) {
  const setModal = useSetAtom(modalAtom);

  return (
    <MenuItem
      size="300"
      after={menuIcon(Smiley)}
      radii="300"
      onClick={(e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
        setModal({
          type: ModalType.Reactions,
          room,
          relations,
        });
      }}
    >
      <Text className={css.MessageMenuItemText} as="span" size="T300" truncate>
        View Reactions
      </Text>
    </MenuItem>
  );
}

type MessageAllReactionInternalProps = {
  room: Room;
  relations: Relations;
  onClose: () => void;
};

export function MessageAllReactionInternal({
  room,
  relations,
  onClose,
}: MessageAllReactionInternalProps) {
  return <ReactionViewer room={room} relations={relations} requestClose={onClose} />;
}
